import { Chip } from "@legal-500/legal500-design-system";
import type { SlotTargetedFlags } from "./useSlotTargetedFlags.js";
import styles from "./DbManager.module.css";

export function targetedFlagsUnknownMessage({
  loading,
  error,
}: Pick<SlotTargetedFlags, "loading" | "error">): string | null {
  if (error) return `Couldn't check slot-only feature flags: ${error.message}`;
  if (loading) return "Checking slot-only feature flags...";
  return null;
}

export function SlotTargetedFlagList({ targetedFlags }: { targetedFlags: SlotTargetedFlags }) {
  const unknownMessage = targetedFlagsUnknownMessage(targetedFlags);
  if (unknownMessage) {
    return <p className={styles.releaseSectionEmpty}>{unknownMessage}</p>;
  }

  if (targetedFlags.flagKeys.length === 0) {
    return (
      <p className={styles.releaseSectionEmpty}>No feature flags switched on only for this slot.</p>
    );
  }

  return (
    <ul className={styles.slotTargetedFlagList}>
      {targetedFlags.flagKeys.map(key => (
        <li key={key}>
          <SlotTargetedFlagChip flagKey={key} />
        </li>
      ))}
    </ul>
  );
}

export function SlotTargetedFlagChip({ flagKey }: { flagKey: string }) {
  return (
    <Chip size="small" color="warning" variant="filled">
      Flag: {flagKey}
    </Chip>
  );
}
